import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { PropsWithChildren, ReactElement } from 'react';
import { DataPointSection, DataPointSectionContent, DataPointSectionHeader } from './data-point-section.style';

interface DataPointSectionComponentProps extends PropsWithChildren {
    title?: string;
    description?: string | ReactElement;
}

export const DataPointSectionComponent: React.FC<DataPointSectionComponentProps> = (props) => {
    const { children, title, description } = props;

    return (
        <DataPointSection>
            <DataPointSectionHeader>
                <PocTypography element="span" variant="button">
                    {title}
                </PocTypography>
                <PocTypography element="p" variant="body1">
                    {description}
                </PocTypography>
            </DataPointSectionHeader>
            <DataPointSectionContent>{children}</DataPointSectionContent>
        </DataPointSection>
    );
};
